type ProductInformation = {
    productName: string;
    productId: string;
};

type UrlProps = {
    slugs: string[];
};

const productUrlRegexp =
    /(?<productName>^(.+))?(^|-)(?<productId>\d{3,7})($|\.html$)/;

export const parseProductNameAndID = (
    productUrlString: string
): ProductInformation => {
    const productInfoMatch = productUrlRegexp.exec(productUrlString)?.groups;
    if (!productInfoMatch) {
        return { productName: '', productId: '' } as ProductInformation;
    }

    const { productName, productId } = productInfoMatch;
    return {
        productName,
        productId,
    } as ProductInformation;
};

export const productInformation = (urlProps: UrlProps) => {
    const slugs = [...urlProps.slugs];

    if (!slugs.length) {
        return { productId: undefined };
    }

    return { ...parseProductNameAndID(slugs.pop() ?? ''), categories: slugs };
};
